import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setQtyRadius,
    setScheduleStep,
    setTechnician,
    setTotalTime
} from "../../../Store/Slice/scheduleSlice";
import Button from "../../../UI/Button";
import ScheduleMap from "./Map";
import TechList from "./TechList";
import InfoText from "./InfoText";
import Form from "./Form";
import TicketInputs from "./TicketInputs";
import Footer from "./Footer";
import moment from "moment/moment";
import useGetTechniciansForMonth from "../../../Global/Api/Schedule/getTechniciansForMonth";
import useGetTechniciansForJob from "../../../Global/Api/Schedule/getTechniciansForJob";
import {useParams} from "react-router-dom";
import {convertTo24Hour} from "../../../Global/Hooks/convertTime";

export default function SchedulingTech() {
    const {title: jobTitle} = useParams();
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.rootReducer.techsbookSlice);
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const { schedule_step: scheduleStep, tech: techData } = useSelector((state) => state.rootReducer.scheduleSlice);
  const { lat: Lat, lon: Lon, technician_id } = useSelector((state) => state.rootReducer.scheduleSlice.sendData);
  const {technicians_for_job} = useSelector((state) => state.rootReducer.scheduleSlice);
  const timesInMonth = useGetTechniciansForMonth();
  const getTechnicians = useGetTechniciansForJob();

  const [isDatePast, setIsDatePast] = useState(false);
  const isButtonDisabled = !(
    techData?.job_address?.address &&
    techData?.date &&
    techData?.time?.start &&
    (techData?.technician_id?.id || techData?.technician?.id) &&
    technicians_for_job?.find(el => el.id === technician_id)?.available && !isDatePast
  );

  const handleSubmit = (step) => {
    dispatch(setScheduleStep(step));
  };

  const fillTechData = async () => {
      await dispatch(setTechnician({
          job_datetime: JSON.stringify(activeJob?.job_datetime) || null,
          job_address: {
              address: activeJob?.address,
              lat: activeJob?.lat,
              lon: activeJob?.lon,
          },
          date: JSON.stringify(activeJob?.job_datetime),
          time: {
              label: `${moment(activeJob?.job_datetime).format("hh:mm A")} - ${moment(activeJob?.job_endtime).format("hh:mm A")}`,
              active: true,
              start: activeJob?.job_datetime,
              end: activeJob?.job_endtime,
          },
          lat: activeJob?.lat,
          lon: activeJob?.lon,
          technician_id: activeJob?.technician,
          technician: activeJob?.technician,
          description: activeJob?.description,
          verification_key: activeJob?.verification_key,
          tracking_number: activeJob?.tracking_number,
          purchase_order: activeJob?.purchase_order,
      }));
      await dispatch(setTotalTime());
      await dispatch(setQtyRadius(userData?.radius_for_tech));
  }

  const fetchTechForMonth = async () => {
      if(Lat && Lon){
          await timesInMonth.get(
              moment(new Date()).format("YYYY"),
              moment(new Date()).format("M"),
              activeJob?.time,
              activeJob?.items?.map(el => el?.product_id)
          );
      }
  }

    const fetchTechForDate = async () => {
        if (!activeJob?.job_datetime) return;

        const formattedDateTime = moment(activeJob.job_datetime)
            .local()
            .format("YYYY-MM-DD hh:mm A");

        const parts = formattedDateTime.split(" ");
        if (parts.length !== 3) {
            console.error("Unexpected date format:", formattedDateTime);
            return;
        }
        const [datePart, timePart, modifier] = parts;

        const convertedTime = convertTo24Hour(`${timePart} ${modifier}`);

        const formattedLocalDate = `${datePart} ${convertedTime}:00`;

        await getTechnicians.get({
            date: formattedLocalDate,
            lat: activeJob?.lat,
            lon: activeJob?.lon,
            radius: userData?.radius_for_tech,
            duration: activeJob?.time,
            product_ids: activeJob?.items?.map(el => el?.product_id),
        });
    };

  useEffect(() => {
    if (!jobTitle) return;
    if (!activeJob?.address || String(activeJob?.title) !== String(jobTitle)) {
        return;
    }
    fillTechData();
    fetchTechForMonth();
    fetchTechForDate();
  }, [jobTitle, activeJob?.address, activeJob?.title]);

    useEffect(() => {
        if (techData?.date) {
            const isPast = moment(techData?.date).isBefore(new Date());
            setIsDatePast(isPast);
        }
    }, [techData?.date]);

  return (
    <div className={`schedule__block ${scheduleStep === 2 ? "active" : ""}`}>
      <h2 className="schedule__title">
        <div>2. Scheduling Tech</div>
        {scheduleStep > 2 && (
          <span onClick={() => handleSubmit(2)}>Change</span>
        )}
      </h2>
      <div className="schedule__hr"></div>
      <div className="schedule__content">
        <div className="tech__content">
          <div className="tech__left">
            <Form isDatePast={isDatePast}/>
            <TechList />
            <TicketInputs />
            <InfoText />
          </div>
          <div className="tech__right">
            <ScheduleMap />
          </div>
        </div>
        <div className="lineitems__footer">
          <Button
            onClick={() => handleSubmit(3)}
            disabled={isButtonDisabled}
            text="Continue"
          />
        </div>
      </div>
      {scheduleStep > 2 && <Footer />}
    </div>
  );
}
